/* eslint-disable react/forbid-prop-types */
import React from 'react';
import PropTypes from 'prop-types';

import { IconButton } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import { COLOR } from 'assets/styles/colors';
import { Button } from 'components/Button';
import { Title, Text } from 'components/Text';
import { useHistory } from 'react-router-dom';
import { createEventTracking } from 'services/api/tracking';
import { StyledDialog, Content, BoxButtons } from './styles';

const AlertModal = ({
  onClose, open,
}) => {
  const history = useHistory();
  return (
    <StyledDialog
      open={open}
      onClose={() => onClose(false)}
    >
      <Content>
        <IconButton
          style={{ color: COLOR.GREEN_1 }}
          onClick={() => onClose(false)}
        >
          <CloseIcon onClick={() => onClose(false)} />
        </IconButton>
        <Title secondary>
          Você já pagou por esse cálculo
        </Title>
        <Text>
          Seu pagamento já foi efetuado e o seu kit já está disponível para Download.
        </Text>
        <Text>
          Caso queira realmente refazer o cálculo, o seu kit será excluído e essa ação não poderá ser desfeita.
        </Text>
        <Text>
          Para ter acesso ao kit com as novas informações de cálculo, precisará efetuar um novo pagamento.
        </Text>
        <BoxButtons>
          <Button
            onClick={async () => {
              await createEventTracking('110 - refazer cálculo');
              history.push('/calculo');
            }}
          >
            Quero refazer o cálculo
          </Button>
          <Button
            onClick={() => history.push('/home')}
            variant="outlined"
          >
            Voltar para tela inicial
          </Button>
        </BoxButtons>
      </Content>
    </StyledDialog>
  );
};

AlertModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default AlertModal;
